<template>
    <div class="page-content">

        <div id="soundlist" class="section grow bg-svg-dunes-night">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <media-artwork
                            v-bind:emitName="emit_config.emitter"
                            v-bind:emitPool="emit_config.pool"
                            v-bind:item="mediaItem"
                            v-bind:itemKey="mediaItemKey"
                            v-bind:showTypeBadge="true"
                            v-bind:showCastButton="true"
                            v-bind:showTitle="true"
                            v-bind:showControls="true"
                            class="w-40 mx-auto mb-5"
                            ref="preview"
                        />

                        <p v-if="mediaItem.description" class="lead mb-5">{{mediaItem.description}}</p>
                        <p v-if="mediaItem.type == 'SOUND'" class="lead mb-5">Sleep sounds like {{mediaName}} are an excellent way to promote better sleep, deeper relaxation, and higher focus. Millions of people listen to our high quality sounds through the Sleep Jar app to improve their quality of sleep, block out distracting noise, or to just unwind after a stressful day.</p>
                        
                        <h3 class="title color-white mt-10 mb-5">{{downloadHeaderText}}</h3>

                        <div class="row text-center">
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.quick_launch.alexa" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-amazon"></i>Alexa</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.android" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-android"></i>Android</a>
                            </div>
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.app_link.ios" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-apple"></i>iPhone</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.firetv" target="_blank" class="btn btn-lg btn-light"><i class="fas mr-2 fa-tv"></i>Fire TV</a>
                            </div>
                        </div>

                        <p v-if="mediaItem.type == 'STORY'" class="lead mt-5"><small class="opacity-50">Stories are not yet available on Fire TV.</small></p>
                        <p v-if="mediaItem.type == 'MEDITATION'" class="lead mt-5"><small class="opacity-50">Meditations are not yet available on Fire TV.</small></p>
                        <p v-if="mediaItem.type == 'JOURNEY'" class="lead mt-5"><small class="opacity-50">Journeys are not yet available on Fire TV.</small></p>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
    data () {
        return {
            "media": require('../assets/media.js'),
            "emit_config": {
                "pool": "sounds",
                "emitter": "sounds-stop"
            }
        };
    },
    name: 'media_detail',
    metaInfo() {
        const mediaDescription = this.mediaItem.description || `Listen to ${this.mediaItem.name} on Sleep Jar for better sleep, relaxation, and focus.`;
        const pageUrl = `https://sleepjar.com${this.$route.path}`;
        return {
            title: this.mediaItem.name,
            meta: [
                {
                    'name': 'apple-itunes-app',
                    'content': 'app-id=1587218079'
                },
                {
                    'name': 'title',
                    'property': 'og:title',
                    'content': this.mediaItem.name
                },
                {
                    'name': 'description',
                    'property': 'og:description',
                    'content': mediaDescription
                },
                {
                    'name': 'image',
                    'property': 'og:image',
                    'content': this.artworkSrc
                },
                {
                    'name': 'url',
                    'property': 'og:url',
                    'content': pageUrl
                },
                {
                    'property': 'twitter:card',
                    'content': 'summary'
                }
            ]
        }
    },
    methods: {
        filteredMediaRoughCount (type = "SOUND") {
            return this.filteredMediaCount(type) - this.filteredMediaCount(type)%10;
        },
        filteredMediaCount (type = "SOUND") {
            var keys = Object.keys(this.filteredMedia[type]);
            return keys.length;
        },
    },
    computed: {
        "mediaItemKey": function(){
            return (this.$route.params.mediaKey || "").toLowerCase();
        },
        "mediaItem": function(){
            return this.media[this.$route.params.mediaKey];
        },
        "mediaName": function(){
            return this.mediaItem.type == "SOUND" ? this.mediaItem.name.toLowerCase() : this.mediaItem.name;
        },
        "mediaTitle": function(){
            return this.mediaItem.type == "SOUND" ? this.mediaItem.title.toLowerCase() : this.mediaItem.title;
        },
        "artworkSrc": function(){
            var url = `https://cdn.sleepjar.com/sleepsounds/images/artwork/${(this.mediaItem.type).toLowerCase()}`;
            if(this.mediaItem.type != "SOUND"){
                url += `/cover/jpg/512x512/${this.mediaItemKey}.jpg`;
            }else{
                url += `/cover/png/512x512/${this.mediaItemKey}.png`;
            }
            return url;
        },
        "downloadHeaderText": function(){
            var mediaTitle = "";
            switch(this.mediaItem.type){
                case "STORY":
                case "MEDITATION":
                case "JOURNEY":
                    mediaTitle = `this ${this.mediaItem.type.toLowerCase()} and ${this.filteredMediaCount(this.mediaItem.type)-1} more`;
                    break;
                default:
                    mediaTitle = `${this.mediaTitle} and ${this.filteredMediaCount(this.mediaItem.type)-1} more sounds`;
                    break;
            }
            return `Listen to ${mediaTitle} with Sleep Jar`;
        },
        "filteredMedia": function(){
            let media = {
                "SOUND": {},
                "STORY": {},
                "MEDITATION": {},
                "JOURNEY": {}
            };
            Object.entries(this.media).forEach(function([key, item]){
                if(!item.published_ts || new Date(item.published_ts).getTime() < new Date().getTime()){
                    media[item.type][key] = item;
                }
            });
            return media;
        }
    },
    components: {
    },
    mounted(){
        EventBus.$on(this.emit_config.emitter, function(){
            this.$refs.preview.stopAudio();
        }.bind(this));
    }
}
</script>
